import React, { useEffect, forwardRef } from 'react'

import iconWindows from '../app/webcomponents/assets/images/icon-windows.svg'
import iconLinux from '../app/webcomponents/assets/images/icon-linux.svg'
import iconMac from '../app/webcomponents/assets/images/icon-macos.svg'

const PackageModule = ({ isWindows, isMacOS, isLinux, moduleAcronym, label, isReadOnly, isChecked, value }, innerRef) => {
    useEffect(() => {
        if (isReadOnly) {
            const checkbox = document.getElementById(moduleAcronym);
            checkbox.disabled = true;
        }
        if (isWindows) {
            const tooltip = document.getElementById(`${moduleAcronym}OsWindows`);
            tooltip.tooltipText = 'Windows';
            tooltip.innerHTML = `<img src=${iconWindows} alt='imgWindows' />`;
        }
        if (isMacOS) {
            const tooltip = document.getElementById(`${moduleAcronym}OsMac`);
            tooltip.tooltipText = 'macOS';
            tooltip.innerHTML = `<img src=${iconMac} alt='imgMacOs' />`;
        }
        if (isLinux) {
            const tooltip = document.getElementById(`${moduleAcronym}OsLinux`);
            tooltip.tooltipText = 'Linux';
            tooltip.innerHTML = `<img src=${iconLinux} alt='imgLinux' />`;
        }
    }, []);

    let module = <gz-form-field id={`module-${moduleAcronym}`} ref={innerRef} {...(isReadOnly ? { readonly: true } : {})}>
        <gz-checkbox id={moduleAcronym} className="form-field-input"
            gz-form-input
            errortooltiptext
            color="primary"
            label={label}
            {...(isChecked ? { checked: true } : {})}
            value={value}
        />
        <gz-input-error></gz-input-error>
    </gz-form-field>

    return (
        <div className='flex flex-row items-center mb-2'>
            {(moduleAcronym === 'cc' || moduleAcronym === 'nad' || moduleAcronym === 'wts' || moduleAcronym === 'aph') && <div className='w-56 ml-2'>
                {module}
            </div>}
            {(moduleAcronym !== 'cc' && moduleAcronym !== 'nad' && moduleAcronym !== 'wts' && moduleAcronym !== 'aph') && <div className='w-64'>
                {module}
            </div>}
            <div className='flex flex-row'>
                <div className='px-3 w-12'>
                    {isWindows && <gz-tooltip id={`${moduleAcronym}OsWindows`}></gz-tooltip>}
                </div>
                <div className='px-3 w-12'>
                    {isMacOS && <gz-tooltip id={`${moduleAcronym}OsMac`}></gz-tooltip>}
                </div>
                <div className='px-3 w-12'>
                    {isLinux && <gz-tooltip id={`${moduleAcronym}OsLinux`}></gz-tooltip>}
                </div>
            </div>
        </div>
    )
}

export default forwardRef(PackageModule);